import type { AxiosInstance } from "axios";

import { parseAxiosResponse } from "@thalamos/common";
import type {
  OrganisationDirectoryPage,
  OrganisationType,
} from "@thalamos/haven-common";
import { OrganisationDirectoryPageSchema } from "@thalamos/haven-common";

import type { ErrorBody, ResponseBody } from "../axios/api.js";
import { useApiAxios } from "../axios/api.js";

const parseResponseOrganisationPage = parseAxiosResponse(
  OrganisationDirectoryPageSchema,
);

/**
 * The bodies of one or more kinds.
 *
 * `type` is required and `query` is not, which is the opposite way round to the
 * people search — listing is what a picker for the duty of care wants, and the
 * kind is what narrows it. A picker derives the kinds from `organisationTypesEligibleFor`,
 * so it cannot offer an organisation the write would refuse.
 */
export type OrganisationQuery = {
  type: readonly OrganisationType[];
  query?: string;
  limit?: number;
};

export const config = {
  organisation: {
    find: ({ type, query, limit }: OrganisationQuery) => ({
      url: "/api/organisations",
      method: "get",
      params: {
        type,
        ...(query !== undefined && query.length > 0 ? { query } : {}),
        ...(limit !== undefined ? { limit } : {}),
      },
      transformResponse: parseResponseOrganisationPage,
    }),
  },
};

export const api = (apiAxios: AxiosInstance) => {
  return {
    organisation: {
      find: (request: OrganisationQuery) =>
        apiAxios.request<ResponseBody<OrganisationDirectoryPage, ErrorBody>>(
          config.organisation.find(request),
        ),
    },
  };
};

export const apiHooks = () => {
  return {
    organisation: {
      find: function useOrganisations(request: OrganisationQuery) {
        return useApiAxios<OrganisationDirectoryPage>(
          config.organisation.find(request),
        );
      },
    },
  };
};
